export const KEY_CODES = {
  LeftArrow: 37,
  UpArrow: 38,
  RightArrow: 39,
  DownArrow: 40,
  End: 35,
  Home: 36,
  Delete: 46,
  Tab: 9,
  Esc: 27,
  Enter: 13,
  Space: 32,
  Backspace: 8,
  Up: 38,
  Down: 40,
  Comma: 188,
  0: 48,
  9: 57,
  Numpad0: 96,
  Numpad9: 105,
  A: 65,
  C: 67,
  R: 82,
  V: 86,
  X: 88,
  ForwardSlash: 191,
};
